import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component
class SubNavigationTitleComponent extends Vue {
  dtSearch: string;
  dtOptions: any[];
  dtAllowMenu: boolean

  @Prop({ required: true })
  title: string;
  @Prop({ default: false, type: [Boolean] })
  value: boolean;
  @Prop({ default: true, type: [Boolean] })
  loadMoreVisible: boolean;

  @Prop({ required: false, default: 'name', type: [String] })
  textField: string;
  @Prop({ default: false, type: [Boolean] })
  titleOnly: boolean;
  @Prop({ default: false, type: [Boolean] })
  closeOnContentClick: boolean;
  @Prop({ default: () => [], type: [Array] })
  source: any[];
  @Prop({ default: 'primary' , type: [String] })
  color: string
  @Prop({ default: '', type: [String] })
  icon: string
  @Prop({ default: false , type: [Boolean] })
  isIcon: boolean
  @Prop({ default: false, type: [Boolean] })
  isLoading: boolean

  /**
   *
   */
  constructor() {
    super();
    this.dtSearch = null;
    this.dtOptions = [];
    this.dtAllowMenu= false
  }

  get lblSetting() {
    return {
      ...require('@/locales/generic-labels').default
    }
  }

  get vModel(): boolean {
    return this.value;
  }
  set vModel(value: boolean) {
    this.$emit('input', value)
  }
  get coAllowMenu(): boolean {
    return this.dtAllowMenu
  }
  set coAllowMenu(value : boolean){
    this.dtAllowMenu= value
  }
  get coSource() {
    console.log('source options ***************',this.dtOptions)
    return (this.dtOptions || []).map(x => ({ value: x.id, text: x[this.textField], ...x }))
  }
  get hasSlot(): boolean {
    return this.$slots.default !== undefined || this.$scopedSlots.default !== undefined;
  }
  get coIcon(){
    const modalIcon = require.context('../../assets/icon/',false,/\.(png|svg)$/)
    return modalIcon(`./${this.icon}.png`)
  }
  handleChange() {
    this.dtOptions = this.source.filter(x => x[this.textField].toLocaleLowerCase().match(this.dtSearch.toLocaleLowerCase()))
  }

  mounted() {
    this.$watch('source', (n, o) => this.dtOptions = JSON.parse(JSON.stringify(n)))
    this.dtOptions = JSON.parse(JSON.stringify(this.source))
  }

  @Emit('click')
  handleItemClicked({ data, index }) {
    //this.titleOnly= !this.titleOnly
  }
  @Emit('loadMore')
  handleLoadMoreClicked({ data, index }) { }

  handleOpenMenu(){
    this.coAllowMenu= true
  }
}

export default SubNavigationTitleComponent;



// WEBPACK FOOTER //
// ./src/components/sub-navigation-title-duplicate/index.ts